/* BLOCK CS.UI.0 — CollapsibleCard */
import React from 'react';

import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';

export default function CollapsibleCard({ header, expanded, children }) {
  return (
    <Paper elevation={3} sx={{ p: 1.5, borderRadius: 2 }}>
      <Stack spacing={1}>
        <Box>{header}</Box>
        <Collapse in={expanded}>
          <Box>{children}</Box>
        </Collapse>
      </Stack>
    </Paper>
  );
}
